// extracted by mini-css-extract-plugin
module.exports = {"footerFirstNav":"Footer_footerFirstNav__9UrHM","footerSecondNav":"Footer_footerSecondNav__j_u8f"};